export const POST_MESSAGE = 'putMessage'
export const POST_MESSAGE_BY_SETTING = 'putMessageBySetting'
export const GET_MESSAGES_LIST = 'getMessagesList'
export const GET_MESSAGE = 'getMessage'
export const GET_MESSAGE_IMAGE = 'getMessageImage'
export const GET_THREADS = 'getThreads'
